// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".system-error[data-v-78750540] {\n  text-align: center;\n  font-size: 20px;\n  line-height: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
